import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';

const ControlPanel = memo(({ position, onPositionChange, onReset }) => {
    const handleScaleChange = useCallback(
        (e) => {
            const newScale = parseFloat(e.target.value);
            // Directly update position - no Redux lag since it's local state
            onPositionChange({ ...position, scale: newScale });
        },
        [position, onPositionChange]
    );

    const handleReset = useCallback(() => {
        onReset();
    }, [onReset]);

    if (!position) return null;

    return (
        <div className="upload-controls">
            <div className="upload-controls__row">
                <label htmlFor="image-scale">Zoom</label>
                <input
                    id="image-scale"
                    type="range"
                    min="0.5"
                    max="3"
                    step="0.1"
                    value={position.scale}
                    onChange={handleScaleChange}
                />
                <span>{(position.scale * 100).toFixed(0)}%</span>
            </div>

            <button type="button" className="btn btn-pill btn-secondary reset-position" onClick={handleReset}>
                Reset zoom & position
            </button>
        </div>
    );
});

ControlPanel.displayName = 'ControlPanel';

ControlPanel.propTypes = {
    position: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        scale: PropTypes.number,
    }).isRequired,
    onPositionChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
};

export default ControlPanel;
